import { LibraryIcon, LibraryIconSymbol } from '@repo/icons/library-icon';

import { cn } from '~/lib/utils';
import { dashify } from '~/utils/dashify';
import { italicizeStarWars } from '~/utils/italicize-star-wars';

import { replaceAsteriskedTextWithFancyUnderline } from './fancy-underline';

interface SectionHeaderProps {
  heading?: string | null;
  copy?: string | null;
  icon?: string | null;
  className?: string;
  size?: 'default' | 'lg';
  as?: 'h1' | 'h2';
  italicizeStarWars?: boolean;
}

export function SectionHeader({
  heading,
  icon,
  copy,
  className,
  size = 'default',
  as: Tag = 'h2',
  italicizeStarWars: shouldItalicizeStarWars = false,
}: SectionHeaderProps) {
  if (!heading) return null;

  const headingContent = replaceAsteriskedTextWithFancyUnderline(heading);

  return (
    <header className={cn('mb-8 text-center lg:mb-12', className)}>
      {icon && (
        <LibraryIcon className='text-yellow mx-auto mb-5' height={32} use={icon as LibraryIconSymbol} width={80} />
      )}
      <Tag
        className={cn('mx-auto max-w-4xl text-balance', size === 'lg' ? 'display-sm' : 'heading-lg')}
        id={dashify(heading)}
      >
        {shouldItalicizeStarWars ? italicizeStarWars(headingContent) : headingContent}
      </Tag>
      {copy && <p className='text-muted-foreground mx-auto mt-5 max-w-2xl lg:text-lg'>{copy}</p>}
    </header>
  );
}
